import Status from '~/components/Status'
import { ObjectiveBasedCampaignBadge } from '~/modules/retailMedia/components/ObjectiveBased'

import * as S from './styles'

type TitleWithStatusProps = {
  title: string
  linkTo: string
  statusColor: StatusTemplates
  isObjectiveBased?: boolean
  goal?: Goals
}

const TitleWithStatus: React.FC<TitleWithStatusProps> = ({
  title,
  linkTo,
  statusColor,
  isObjectiveBased = false,
  goal
}) => {
  return (
    <S.Wrapper>
      {!!isObjectiveBased && <ObjectiveBasedCampaignBadge goal={goal} />}
      <S.WrapperLink to={linkTo}>
        <S.Container>
          <Status
            onlyBullet
            status={{
              type: statusColor || 'default'
            }}
          />

          <span className="title">{title}</span>
        </S.Container>
      </S.WrapperLink>
    </S.Wrapper>
  )
}

export default TitleWithStatus
